module.exports = __webpack_public_path__ + "img/music-note-list.72325a73.svg";